module.exports = __webpack_public_path__ + "static/media/icon-happy-meds.70f36416.png";